import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home/home-page.component';
import { HowItWorksPageComponent } from './pages/how-it-works/how-it-works-page.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { DatenschutzComponent } from './datenschutz/datenschutz.component';

export const routes: Routes = [
  { path: '', component: HomePageComponent, title: 'Home' },
  { path: 'how-it-works', component: HowItWorksPageComponent, title: 'How it works' },
  { path: 'impressum', component: ImpressumComponent },
  { path: 'privacy-policy', component: DatenschutzComponent },
  { path: '**', redirectTo: '' },
];
